//  票务、讲解、活动三个模块
export default [
    //  票务服务
    {
        path: '/ticketing',
        name: 'ticketing',
        component: () => import('../views/home/ticketing.vue'),
    },
    //  直播讲解
    {
        path: '/videoLiveList',
        name: 'videoLiveList',
        component: () => import('../views/home/videoLiveList.vue'),
        meta: {
            title: '直播讲解'
        }
    },
    // 虚拟海博
    {
        path: '/VirtualHall',
        name: 'VirtualHall',
        component: () => import('../views/home/VirtualHall.vue'),
        meta: {
            title: '虚拟海博'
        }
    },
    //  海博视界
    {
        path: '/videoList',
        name: 'videoList',
        component: () => import('../views/home/videoList.vue'),
        meta: {
            title: '海博视界'
        }
    },
    //  日历选择时间
    {
        path: '/calendar',
        name: 'calendar',
        component: () => import('../views/home/calendar.vue'),
        meta: {
            title: '门票预约'
        }
    },
    //  活动日历选择时间
    {
        path: '/activityCalendar',
        name: 'activityCalendar',
        component: () => import('../views/home/activityCalendar.vue'),
        meta: {
            title: '活动预约'
        }
    },
    //  临展详情
    {
        path: '/exhibition',
        name: 'exhibition',
        component: () => import('../views/home/exhibitionDetail.vue'),
        meta: {
            title: '临展详情'
        }
    },
    //  填写票务信息
    {
        path: '/fillTicketingInfo',
        name: 'fillTicketingInfo',
        component: () => import('../views/home/fillTicketingInfo.vue'),
        meta: {
            title: '填写预约信息'
        }
    },
    //  票务预约成功
    {
        path: '/ticketingInfoSuccess',
        name: 'ticketingInfoSuccess',
        component: () => import('../views/home/ticketingInfoSuccess.vue'),
        meta: {
            title: '门票预约'
        }
    },
    //  讲解预约
    {
        path: '/explainPage',
        name: 'explainPage',
        component: () => import('../views/home/explainHome.vue'),
        meta: {
            title: '讲解预约'
        }
    },
    //  查看讲解员
    {
        path: '/narrator',
        name: 'narrator',
        component: () => import('../views/home/narratorPage.vue'),
        meta: {
            title: '查看讲解员'
        }
    },
    //  讲解预约成功
    {
        path: '/narratorSuccess',
        name: 'narratorSuccess',
        component: () => import('../views/home/narratorSuccessPage.vue'),
        meta: {
            title: '讲解预约'
        }
    },

    //  活动首页
    {
        path: '/activityPage',
        name: 'activityPage',
        component: () => import('../views/home/activityHomePage.vue'),
        meta: {
            title: '活动预约'
        }
    },
    //  活动详情
    {
        path: '/activityDetail',
        name: 'activityDetail',
        component: () => import('../views/home/activityDetailPage.vue'),
        meta: {
            title: '活动详情'
        }
    },
    //  填写活动信息
    {
        path: '/fillActivityInfo',
        name: 'fillActivityInfo',
        component: () => import('../views/home/fillActivityInfo.vue'),
        meta: {
            title: '活动报名'
        }
    },
    //  活动预约成功
    {
        path: '/activitySuccess',
        name: 'activitySuccess',
        component: () => import('../views/home/activitySuccessPage.vue'),
        meta: {
            title: '活动预约'
        }
    },
    //  楼层导览
    {
        path: '/drawingMapBoot',
        name: 'drawingMapBoot',
        component: () => import('../views/home/drawingMapBoot.vue'),
        meta: {
            title: '导览'
        }
    },
    //  位置服务
    {
        path: '/drawingMap',
        name: 'drawingMap',
        component: () => import('../views/home/drawingMap.vue'),
        meta: {
            title: '位置服务'
        }
    },
];